export enum APPLICANT_RELATION {
  SUBSCRIBER = 'SUBSCRIBER',
  DEPENDENT = 'DEPENDENT',
  SPOUSAL_PARTNER = 'SPOUSE',
  DOMESTIC_PARTNER = 'DOMESTICPARTNER'
}

export const SPOUSE_RELATIONSHIPS = [
  APPLICANT_RELATION.SPOUSAL_PARTNER,
  APPLICANT_RELATION.DOMESTIC_PARTNER
]

export interface Applicant {
  dob: string; // '1988-11-11',
  tobaccoStatus: 'Y' | 'N'; // 'N',
  relationship: APPLICANT_RELATION; // 'Subscriber'
  personId?: number;
}
